import React from 'react';

export type ShowHideDivProps = {
    id?: string,
    show?: boolean,
    children?: React.ReactNode,
    className?: string,
}

export const invisibleClass = 'invisible'

const ShowHideDiv = (props: ShowHideDivProps) => {
    const mergedClassName = `${props.show ? 'visible' : invisibleClass}${props.className ? ` ${props.className}` : ''}`;

    return (
        <div {...props} className={mergedClassName} >
            {props.children}
        </div>
    )
};
export default ShowHideDiv;